import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import { State } from '@hookstate/core';

export const Container = styled.div`
  position: relative;
  max-height: 400px;
`;

export const Button = styled.button`
  background: ${beam.background.whiteButton};
  border-radius: 12px;
  padding: 0 10px;
  cursor: pointer;
  user-select: none;
  height: 24px;
  display: flex;
  align-items: center;
  color: ${beam.color.pureWhite};
  margin-left: 8px;
  border: none;
`;

interface BlockProps {
  pageCategory: State<'tag_category' | 'new_tag_category' | 'unset'>;
}
export const Block = styled.div<BlockProps>`
  background: ${beam.color.pureWhite};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  top: 24px;
  min-width: 350px;
  height: 497px;
  z-index: 999;
  left: 0;
`;

export const Title = styled.div`
  color: ${beam.font.primary};
  font-size: 24px;
  margin-bottom: 16px;
`;

export const Icon = styled.div`
  margin-right: 8px;
`;
interface BlockProps {
  pageCategory: State<'tag_category' | 'new_tag_category' | 'unset'>;
  minLeft: number;
}
export const BlockTag = styled.div<BlockProps>`
  background: ${beam.color.pureWhite};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: ${({ pageCategory }) =>
    pageCategory.get() !== 'unset' ? ' 8px 0 0 8px' : '8px'};
  position: absolute;
  top: 16px;
  min-width: 350px;
  z-index: 999;
  height: 530px;
  left: ${({ minLeft }) => `${minLeft + 16}px`};
`;
